/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var setScrollingTextStyle = function () {
  window.fitText(document.getElementById("scrolling-text-h3"), 1.8);
  window.fitText(document.getElementById("scrolling-text-1"), 1.8);
  
  var scrollingTextHeight = parseFloat(document.getElementById("scrolling-text-1").style.fontSize, 10);

  document.getElementById("scrolling-text-mask").style.height = (scrollingTextHeight + 10).toString() + 'px';
  document.getElementById("scrolling-text-1").style.top = scrollingTextHeight.toString() + 'px';
  document.getElementById("scrolling-text-2").style.top = scrollingTextHeight.toString() + 'px';
  document.getElementById("scrolling-text-3").style.top = scrollingTextHeight.toString() + 'px';
  document.getElementById("scrolling-text-4").style.top = scrollingTextHeight.toString() + 'px';
}

setScrollingTextStyle();
document.getElementById("scrolling-text-mask").style.overflow = "hidden";

var setFontSize = function () {
  var mqSmall = window.matchMedia( "(max-width: 639px)" );
  if (mqSmall.matches) {
    window.fitText(document.getElementById("department-desc1-text"), 1.4);
    window.fitText(document.getElementById("department-desc2-text"), 1.4);
    window.fitText(document.getElementById("department-desc3-text"), 1.4);
    window.fitText(document.getElementById("department-desc4-text"), 1.4);
  }

  var mqMedium1 = window.matchMedia( "(min-width: 640px) and (max-width: 999px)" );
  if (mqMedium1.matches) {
    window.fitText(document.getElementById("department-desc1-text"), 1.0);
    window.fitText(document.getElementById("department-desc2-text"), 1.0);
    window.fitText(document.getElementById("department-desc3-text"), 1.0);
    window.fitText(document.getElementById("department-desc4-text"), 1.0);
  }

  var mqMedium2 = window.matchMedia( "(min-width: 1000px) and (max-width: 1279px)" );
  if (mqMedium2.matches) {
    window.fitText(document.getElementById("department-desc1-text"), 1.0);
    window.fitText(document.getElementById("department-desc2-text"), 1.0);
    window.fitText(document.getElementById("department-desc3-text"), 1.0);
    window.fitText(document.getElementById("department-desc4-text"), 1.0);
  }

  var mqLarge = window.matchMedia( "(min-width: 1280px)" );
  if (mqLarge.matches) {
    window.fitText(document.getElementById("department-desc1-text"), 1.0);
    window.fitText(document.getElementById("department-desc2-text"), 1.0);
    window.fitText(document.getElementById("department-desc3-text"), 1.0);
    window.fitText(document.getElementById("department-desc4-text"), 1.0);
  }

  const departmentDescriptionTextSize1 = parseFloat(document.getElementById("department-desc1-text").style.fontSize, 10);
  const departmentDescriptionTextSize2 = parseFloat(document.getElementById("department-desc2-text").style.fontSize, 10);
  const departmentDescriptionTextSize3 = parseFloat(document.getElementById("department-desc3-text").style.fontSize, 10);
  const departmentDescriptionTextSize4 = parseFloat(document.getElementById("department-desc4-text").style.fontSize, 10);
  
  const departmentDescriptionsTextSizes = [departmentDescriptionTextSize1,
                                         departmentDescriptionTextSize2,
                                         departmentDescriptionTextSize3,
                                         departmentDescriptionTextSize4];

  const smallestDepartmentDescriptionTextSize = Math.min.apply(Math, departmentDescriptionsTextSizes);

  const smallestDepartmentDescriptionTextSizeString = smallestDepartmentDescriptionTextSize.toString();
  const departmentTexts = document.querySelectorAll('.department-logo-text');

  departmentTexts.forEach(text => {
    text.style.fontSize = smallestDepartmentDescriptionTextSizeString + 'px';
  });
}

setFontSize();

const body = document.querySelector('body');

var ro = new ResizeObserver( entries => {
  for (let entry of entries) {
    if(entry.contentBoxSize) {
      setFontSize();
      setScrollingTextStyle();
    }
  }
});

ro.observe(body);
